export default __webpack_public_path__ + "static/media/laundry2-afterB-1920w.ebfdedd9.webp";